export { default } from './BasicCard';
export * from './BasicCard';
